import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteConvertAtom = createMutationAtomFactory(
  'brokerage.quoteConvert',
  (params: { id: string; orderId?: string }) => ({
    tradeQuoteConvert: {
      __args: {
        id: params.id,
        ...(params.orderId ? { orderId: params.orderId } : {}),
      },
      id: true,
      status: true,
      convertedToOrderId: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
